/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NatureFxLightningAIcon24Solid = forwardRef('NatureFxLightningAIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8.128 2a1.5 1.5 0 0 0-1.477 1.236l-1.607 9A1.5 1.5 0 0 0 6.521 14h2.51l-1.286 7.716c-.19 1.142 1.26 1.792 1.986.891l8.995-11.166c.79-.981.092-2.441-1.168-2.441h-3.189l1.454-5.088A1.5 1.5 0 0 0 14.381 2H8.128Z" })));
});
